import * as React from "react";

import { TextAreaContainer, TextArea, Label, Error } from './textarea-component';

type Props = {
  label?: string;
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
  register?: any;
  onBlur?: (e: any) => void;
  disable?: boolean;
  star?: string;
  onKeyUp?: (e: any) => void;
  id?: string;
  className?: string;
  pattern?: string;
  error?: string;
  autoFocus?: boolean;
  defaultValue?: any;
  rows?: number;
};

export default function Textarea({
  label,
  placeholder,
  name,
  value,
  onChange,
  register,
  onBlur,
  disable,
  onKeyUp,
  className,
  id,
  autoFocus,
  defaultValue,
  error,
  rows
}: Props) {

  return (
    <>
      <TextAreaContainer>
        {label && <Label>{label}</Label>}
        <TextArea
          placeholder={placeholder}
          name={name}
          value={value}
          rows={rows}
          onChange={onChange}
          ref={register}
          onBlur={onBlur}
          disabled={disable}
          onKeyUp={onKeyUp}
          id={id}
          className={className}
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          maxLength={65000}
        />
        {error && <Error>{error}</Error>}
      </TextAreaContainer>
    </>
  );
}
